import { render, staticRenderFns } from "./TemplatesMenu.vue?vue&type=template&id=3d3cb9fe&scoped=true&"
import script from "./TemplatesMenu.vue?vue&type=script&lang=js&"
export * from "./TemplatesMenu.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesMenu.vue?vue&type=style&index=0&id=3d3cb9fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3cb9fe",
  null
  
)

export default component.exports